/** Shape of the error object returned by Better Auth client calls. */
export interface AuthClientError {
    status?: number | undefined;
    code?: string | undefined;
    message?: string | undefined;
}

const byCode: Record<string, string> = {
    INVALID_EMAIL_OR_PASSWORD: 'That email and password do not match.',
    INVALID_PASSWORD: 'That password is not right.',
    EMAIL_NOT_VERIFIED: 'Verify your email first. The link is in your inbox.',
    USER_ALREADY_EXISTS: 'An account with that email already exists. Sign in instead.',
    USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: 'An account with that email already exists.',
    PASSWORD_TOO_SHORT: 'Use at least 10 characters.',
    PASSWORD_TOO_LONG: 'That password is too long.',
    INVALID_TOKEN: 'This link has expired or was already used. Request a new one.',
    TOKEN_EXPIRED: 'This link has expired. Request a new one.',
    SESSION_EXPIRED: 'Your session has expired. Sign in again.',
    CREDENTIAL_ACCOUNT_NOT_FOUND: 'This account has no password set.',
    USER_NOT_FOUND: 'No account matches that email.',
};

/**
 * Turns a Better Auth client error into a sentence a parent can act on.
 * The API's rate limiter answers 429 with its own envelope, so status is checked first.
 */
export function authErrorMessage(
    error: AuthClientError | null | undefined,
    fallback: string,
): string {
    if (!error) {
        return fallback;
    }
    if (error.status === 429) {
        return 'Too many attempts. Try again in a minute.';
    }
    if (error.code !== undefined) {
        const known = byCode[error.code];
        if (known !== undefined) {
            return known;
        }
    }
    if (error.message !== undefined && error.message.length > 0) {
        return error.message;
    }
    return fallback;
}
